var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.837 2.482a1.271 1.271 0 0 0-1.903-.118l-1.938 1.94c-.906.908-1.24 2.192-.844 3.319a32.94 32.94 0 0 0 7.815 12.39 32.943 32.943 0 0 0 12.39 7.815c1.127.396 2.411.062 3.319-.844l1.938-1.939a1.272 1.272 0 0 0-.118-1.903l-4.325-3.363a1.273 1.273 0 0 0-1.088-.23l-4.106 1.027a3.272 3.272 0 0 1-3.107-.861l-4.605-4.607a3.272 3.272 0 0 1-.863-3.107l1.028-4.106a1.27 1.27 0 0 0-.229-1.088L6.837 2.482ZM3.52.95a3.272 3.272 0 0 1 4.897.306l3.364 4.323a3.27 3.27 0 0 1 .59 2.802l-1.025 4.106a1.271 1.271 0 0 0 .334 1.205l4.607 4.607a1.272 1.272 0 0 0 1.207.334l4.105-1.026a3.27 3.27 0 0 1 2.8.591l4.325 3.364a3.27 3.27 0 0 1 .305 4.895l-1.939 1.94c-1.387 1.387-3.46 1.996-5.394 1.315a34.939 34.939 0 0 1-13.144-8.287A34.939 34.939 0 0 1 .264 8.283c-.679-1.931-.07-4.007 1.318-5.394L3.52.949h-.002Z",
    fill: "#2C112D"
  })));
};
export default SvgPhone;